import React from 'react';
import { ExclamationTriangleIcon, ArrowRightIcon } from '@heroicons/react/24/outline';

const SuccessionPlanningTileFallback = () => {
  return (
    <div className="bg-succession-bg-primary shadow-succession-md rounded-lg p-6 border border-succession-border transition-colors duration-300">
      <div className="flex items-center justify-between mb-5">
        <h3 className="text-lg font-medium text-succession-text-primary transition-colors duration-300">
          Succession Planning
        </h3>
        <ExclamationTriangleIcon className="h-6 w-6 text-succession-warning transition-colors duration-300" />
      </div>

      <div className="space-y-4">
        {/* Warning Badge */}
        <div className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-succession-warning-bg text-succession-warning transition-colors duration-300">
          Service Unavailable
        </div>

        {/* Error Description */}
        <p className="text-sm text-succession-text-secondary leading-relaxed transition-colors duration-300">
          We're having trouble loading your succession planning data. Please try again later or contact support if the problem persists.
        </p>

        {/* Action Button */}
        <div className="pt-2">
          <button
            onClick={() => window.location.reload()}
            className="inline-flex items-center justify-center px-4 py-2 text-sm font-medium text-succession-primary bg-succession-bg-primary border border-succession-border rounded-md hover:bg-succession-bg-secondary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-succession-primary transition-all duration-300"
          >
            Try Again
            <ArrowRightIcon className="w-4 h-4 ml-2" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default SuccessionPlanningTileFallback; 